import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Router } from 'react-router-dom'
import { Loader, LocalizationProvider } from '@carsys/ui'
import { YupI18nProvider } from '@carsys/form/src/YupI18n'
import Routes from 'routes/Routes'
import { AppSetup } from 'utils-support/AppSetup'
import history from 'utils-support/history'
import { EnvironmentProvider } from './contexts/EnvironmentContext'
import SupportFeaturesContextProvider from './contexts/Features/SupportFeaturesContextProvider'
import { XDomainContextProvider } from './contexts/XDomainContext'
import SupportThemeProvider from './theme/ThemeContext'
import { I18nContextProvider } from './contexts/I18nContext'
import { SupportDataGridConfigProvider } from './contexts/ListConfig/SupportDataGridConfigProvider'
import QueryClientProvider from './QueryClientProvider'
import StoreProvider from './StoreProvider'
import SnackBarProvider from 'app-support/notifications/SnackBarProvider'
import ModalContainer from 'react-modal-promise'

function Application() {
  return (
    <DndProvider backend={HTML5Backend}>
      <QueryClientProvider>
        <XDomainContextProvider>
          <StoreProvider>
            <AppSetup>
              <EnvironmentProvider>
                <SupportThemeProvider>
                  <SupportFeaturesContextProvider>
                    <React.Suspense fallback={<Loader loading />}>
                      <I18nContextProvider>
                        <LocalizationProvider>
                          <SupportDataGridConfigProvider>
                            <YupI18nProvider>
                              <SnackBarProvider>
                                <ModalContainer />
                                <Router history={history}>
                                  <Routes />
                                </Router>
                              </SnackBarProvider>
                            </YupI18nProvider>
                          </SupportDataGridConfigProvider>
                        </LocalizationProvider>
                      </I18nContextProvider>
                    </React.Suspense>
                  </SupportFeaturesContextProvider>
                </SupportThemeProvider>
              </EnvironmentProvider>
            </AppSetup>
          </StoreProvider>
        </XDomainContextProvider>
      </QueryClientProvider>
    </DndProvider>
  )
}

export default Application
